module.exports = " <div class=\"g-recaptcha ga-recapthcha\" data-theme=light v-el:container></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/components/recaptcha/recaptcha.vue
// module id = 332
// module chunks = 0